import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Die Listen-Filter lagen früher hier (nur für die laufende Sitzung, beim
// Neuladen zurückgesetzt). Sie liegen jetzt in lib/gemerkterFilter.ts, weil
// sie laut Callcenter-Feedback vom 17.08.2026 auch ein Neuladen überstehen
// sollen und jede Liste denselben Mechanismus bekommt — nicht nur die Kunden.

interface UiState {
  // Ausgeblendete Hilfetexte je Seite (pro Agent gemerkt). Default: eingeblendet.
  helpDismissed: Record<string, boolean>;
  setHelpDismissed: (id: string, dismissed: boolean) => void;
  // Klappmenü am Nutzernamen offen? Liegt hier, damit die Einführungstour es
  // aufziehen kann, um zu zeigen, was darin steckt.
  userMenuOpen: boolean;
  setUserMenuOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set, get) => ({
      helpDismissed: {},
      setHelpDismissed: (id, dismissed) =>
        set({ helpDismissed: { ...get().helpDismissed, [id]: dismissed } }),
      userMenuOpen: false,
      setUserMenuOpen: (open) => set({ userMenuOpen: open }),
    }),
    {
      name: 'cc-ui',
      // Nur die Hilfetexte dauerhaft speichern; das Klappmenü startet bei
      // jedem Laden geschlossen.
      partialize: (s) => ({ helpDismissed: s.helpDismissed }),
    },
  ),
);
